<app-menu class="menuApp" xmlns="http://www.w3.org/1999/html"></app-menu>
<div class="main">
  <div style="width: 90%; height: 100%; margin: auto; padding-top: 2vh">

    <!-- HEADERS -->
    <div (click)="toIndicators()" class="row deviceSection">
      <div class="deviceHeader">
        <h1 *ngIf="indicatorNumber == 0" class="centerVert textXXM">{{this.localiser.get("indicators.health")}}</h1>
        <h1 *ngIf="indicatorNumber == 1" class="centerVert textXXM">{{this.localiser.get("indicators.energy")}}</h1>
        <h1 *ngIf="indicatorNumber == 2" class="centerVert textXXM">{{this.localiser.get("indicators.daliData")}}</h1>
        <h1 *ngIf="indicatorNumber == 3" class="centerVert textXXM">{{this.localiser.get("indicators.emissions")}}</h1>
        <h1 *ngIf="indicatorNumber == 4" class="centerVert textXXM">{{this.localiser.get("indicators.presences")}}</h1>
      </div>
    </div>

    <!-- BODY & CHARTS -->
    <div class="row" class="bodyChart">

      <!-- PRESENCE -->
      <div *ngIf="indicatorNumber == 4">

        <div class="filterRow">
          <div class="col-4" style="margin: auto">
            <h3 class="textS+" style="color: #18264f; margin: auto">{{this.localiser.get('devices.searcher')}}</h3>
            <div class="searcherDiv">
              <div class="col-2" style="text-align: right">
                <span class="material-icons-outlined textXM centerVert" style="color: #18264f">
                  search
                </span>
              </div>
              <!-- [(ngModel)]="searcherLuminarias"  (input)="searcherLuminariasFunc()" -->
              <div class="col" style="text-align: left;">
                <input [(ngModel)]="searcherLuminarias"  (input)="searcherLuminariasFunc()" type="text"
                       class="centerVert textS searcherInput" placeholder=" " maxlength="50">
              </div>
            </div>
          </div>

          <div class="col-4" style="margin: auto">
            <h3 class="textS+" style="color: #18264f">Plano</h3>
            <mat-select class="upperButton textS" (selectionChange)="selectPlano($event.value)" [(ngModel)]="planoSelected">
              <!--(ngModelChange)="changeEmpresa($event)" [(ngModel)]="empresaSeleccionada.nombre"-->

              <mat-option class="textS" [value]="-1">All</mat-option>
              <mat-option class="textS" *ngFor="let plano of planos"
                          [value]="plano">{{plano.nombre}}</mat-option>
            </mat-select>
          </div>
          <div class="col-4" style="margin: auto">
            <h3 class="textS+" style="color: #18264f">Zona</h3>
            <mat-select class="upperButton textS" (selectionChange)="selectZona($event.value)" [(ngModel)]="zonaSelected">
              <!--(ngModelChange)="changeEmpresa($event)" [(ngModel)]="empresaSeleccionada.nombre"-->
              <mat-option class="textS" [value]="-1">All</mat-option>
              <mat-option class="textS" *ngFor="let zona of showZonas" [value]="zona">{{zona.nombre}}</mat-option>
            </mat-select>
          </div>
        </div>

        <div class="row" style="height: 84%; margin-top: 2%">
          <div class="col-4">
            <div class="col luminariasList">
              <h4 class="textS+" style="text-decoration: underline">
                {{this.localiser.get("floorplans.lumList")}}
              </h4>
              <div *ngFor="let luminaria of this.luminarias; index as i" class="luminariaBox">
                <div (click)="changeSelectLum(luminaria)" class="luminariaRow"
                     [ngClass]="{'selectedRow': checkSelectedLuminaria(luminaria)}">
                  <h6 class="textS" style="text-decoration: underline; margin: 1% auto"> {{luminaria.nombre}} </h6>
                  <h6 class="textS" style="margin: 1% auto"> {{luminaria.idDispositivo}} </h6>
                </div>
                <h6 class="textS" style="width: 10%; margin: auto">
                  {{luminaria.presencias}}
                </h6>
              </div>
            </div>
          </div>
          <div class="col-7">
            <div class="row" style="height: 85%">
              <canvas id="presenciasChart"></canvas>
            </div>
            <div class="row" style="height: 15%; margin: auto; width: fit-content">
              <button class="leftButton" (click)="changePresenciasFilterTime(1)"
                      [ngClass]="{'selectedButton': this.presenciasFilterTime == 1}">HOY</button>
              <button class="centerButton" (click)="changePresenciasFilterTime(2)"
                      [ngClass]="{'selectedButton': this.presenciasFilterTime == 2}">AYER</button>
              <button class="centerButton" (click)="changePresenciasFilterTime(3)"
                      [ngClass]="{'selectedButton': this.presenciasFilterTime == 3}">SEMANA</button>
              <button class="centerButton" (click)="changePresenciasFilterTime(4)"
                      [ngClass]="{'selectedButton': this.presenciasFilterTime == 4}">MES</button>
              <button class="rightButton" (click)="changePresenciasFilterTime(5)"
                      [ngClass]="{'selectedButton': this.presenciasFilterTime == 5}">AÑO</button>
            </div>
          </div>
        </div>

      </div>

      <div *ngIf="indicatorNumber == 3" style="margin: auto; padding-top: 3vh">
        <img class="emiImg" src="../../../../assets/img/Emissions.png" alt="Emissions image">

        <button (click)="toIndicators()" class="backButton" style="margin-top: 5vh">
          <span class="material-icons-outlined textL">
          undo
          </span>
        </button>
      </div>

      <div *ngIf="indicatorNumber != 4" class="col-6" style="height: 50vh">
        <div class="chart">
          <h3 *ngIf="indicatorNumber == 0"
              class="text-center textM">{{this.localiser.get("indicators.presenceSensor")}}</h3>
          <h3 *ngIf="indicatorNumber == 1" class="text-center textM">kWh</h3>
          <canvas id="left"></canvas>
          <button *ngIf="indicatorNumber == 0" (click)="changePresenceChart('today')" class="leftButton"
                  [ngClass]="{'selectedButton': this.presenceToday}">{{this.localiser.get("indicators.today")}}</button>
          <button *ngIf="indicatorNumber == 0" (click)="changePresenceChart('week')" class="rightButton"
                  [ngClass]="{'selectedButton': !this.presenceToday}">{{this.localiser.get("indicators.thisWeek")}}</button>
          <button *ngIf="indicatorNumber == 1" (click)="changekWChart('today')" class="leftButton"
                  [ngClass]="{'selectedButton': this.kWToday == 0}">{{this.localiser.get("indicators.thisWeek")}}</button>
          <button *ngIf="indicatorNumber == 1" (click)="changekWChart('week')" class="centerButton"
                  [ngClass]="{'selectedButton': this.kWToday == 1}">{{this.localiser.get("indicators.lastWeek")}}</button>
          <button *ngIf="indicatorNumber == 1" (click)="changekWChart('month')" class="rightButton"
                  [ngClass]="{'selectedButton': this.kWToday == 2}">{{this.localiser.get("indicators.month")}}</button>
        </div>
      </div>

      <div *ngIf="indicatorNumber == 2" class="col-6" style="height: 50vh; position: absolute; width: 40%">

        <div class="chart">
          <div class="col luminariasList">
            <h4 style="text-decoration: underline">
              {{this.localiser.get("floorplans.lumList")}}
            </h4>
            <div *ngFor="let luminaria of this.luminarias; index as i" class="luminariaBox">
              <div (click)="selectLum(luminaria)" class="luminariaRow col-10"
                   [ngClass]="{'selectedRow': this.selectedLum.idDispositivo == luminaria.idDispositivo}">
                <h6 class="textS+" style="text-decoration: underline; margin: 1% auto"> {{luminaria.nombre}} </h6>
                <h6 class="textS" style="margin: 1% auto"> {{luminaria.idDispositivo}} </h6>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div *ngIf="indicatorNumber != 4" class="col-6">
        <div class="chart">
          <h3 *ngIf="indicatorNumber == 0" class="text-center textM">{{this.localiser.get("indicators.noise")}}</h3>
          <h3 *ngIf="indicatorNumber == 1" class="text-center textM">Tn CO2</h3>
          <h3 *ngIf="indicatorNumber == 2" class="text-center textM">Wh & Temp (ºC)</h3>
          <canvas id="right"></canvas>
          <button *ngIf="indicatorNumber == 0" (click)="changeNoiseChart('today')" class="leftButton"
                  [ngClass]="{'selectedButton': this.noiseToday}">{{this.localiser.get("indicators.today")}}</button>
          <button *ngIf="indicatorNumber == 0" (click)="changeNoiseChart('yesterday')" class="rightButton"
                  [ngClass]="{'selectedButton': !this.noiseToday}">{{this.localiser.get("indicators.yesterday")}}</button>
          <button *ngIf="indicatorNumber == 1" (click)="changeCO2Chart('today')" class="leftButton"
                  [ngClass]="{'selectedButton': this.co2Today == 0}">{{this.localiser.get("indicators.thisWeek")}}</button>
          <button *ngIf="indicatorNumber == 1" (click)="changeCO2Chart('week')" class="centerButton"
                  [ngClass]="{'selectedButton': this.co2Today == 1}">{{this.localiser.get("indicators.lastWeek")}}</button>
          <button *ngIf="indicatorNumber == 1" (click)="changeCO2Chart('month')" class="rightButton"
                  [ngClass]="{'selectedButton': this.co2Today == 2}">{{this.localiser.get("indicators.month")}}</button>
          <button *ngIf="indicatorNumber == 2" (click)="changeLuminariaChart(10)" class="leftButton"
                  [ngClass]="{'selectedButton': this.luminariaToday == 10}">{{this.localiser.get("indicators.last10")}}</button>
          <button *ngIf="indicatorNumber == 2" (click)="changeLuminariaChart(20)" class="centerButton"
                  [ngClass]="{'selectedButton': this.luminariaToday == 20}">{{this.localiser.get("indicators.last20")}}</button>
          <button *ngIf="indicatorNumber == 2" (click)="changeLuminariaChart(30)" class="rightButton"
                  [ngClass]="{'selectedButton': this.luminariaToday == 30}">{{this.localiser.get("indicators.last30")}}</button>
        </div>
      </div>
    </div>

    <button *ngIf="indicatorNumber != 3" (click)="toIndicators()" class="backButton">
        <span class="material-icons-outlined textL">
        undo
        </span>
    </button>


  </div>
</div>
